import '../../components/Status.css';
import { Typography } from '@material-ui/core';

import React from 'react';

interface Props {}

const Progress: React.FC<Props> = props => {
  return (
    <div className="Confirmation">
      <div className="content">
        <Typography variant="h4">Order is in a progress</Typography>
      </div>
    </div>
  );
};

export default Progress;
